import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import moment from 'moment';
import {apiRequest, apiPost, apiDelete} from '../../utils/request';
import {toastr} from 'react-redux-toastr';
import 'react-table/react-table.css';
import ReactTable from 'react-table';
import ClosedPeriodView from "./ClosedPeriodView";

export const dateFormat = 'YYYY-MM-DD';

class ClosedPeriodsView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      closedPeriods: [],
      loading: true,
      selectedClosedPeriod: null,
      isOpen: false,
    };

    this.handleNew = this.handleNew.bind(this);
    this.getColumns = this.getColumns.bind(this);
    this.handleSelectDelete = this.handleSelectDelete.bind(this);
    this.handleSelectEdit = this.handleSelectEdit.bind(this);
    this.saveClosedPeriod = this.saveClosedPeriod.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
  }


  handleNew() {
    let count = this.state.closedPeriods.reduce((a, b) => {
      return b.id < 0 ? a + 1 : a;
    }, 0);

    this.setState({
      isOpen: true,
      selectedClosedPeriod: {
        id: (-1 - count),
        dateFrom: moment(new Date()).format(dateFormat),
        dateTo: moment(new Date()).format(dateFormat),
        description: '',
      },
    });
  }

  handleSelectDelete(e, item) {
    e.preventDefault();

    let {locationId} = this.props;

    if (confirm('Are you sure you want to delete this closed period?')) {
      apiDelete(`/api/closedPeriods/${locationId}`, item)
          .then(x => {
            if (x.error || x.data.Message) {
              toastr.error(`Error while deleting, error: ${x.error ? x.error : x.data.Message}`);
              throw 'Error while deleting';
            } else {
              this.loadData(false);
            }
          });
    }
  }

  handleSelectEdit(e, item){
    e.preventDefault();
    this.setState({selectedClosedPeriod: item, isOpen: true});
  }

  saveClosedPeriod(input) {
    let {locationId} = this.props;
    let {closedPeriods} = this.state;

    apiPost(`/api/closedPeriods/${locationId}`, input)
        .then(x => {
          if (x.error || x.data.Message) {
            toastr.error(`Error while saving, error: ${x.error ? x.error : x.data.Message}`);
            throw 'Error while saving contact';
          } else {
            if (input.id <= 0) {
              this.setState({
                selectedClosedPeriod: null,
                isOpen: false,
                closedPeriods: [...closedPeriods, {...x.data}]
              });
            } else {
              this.setState({
                selectedClosedPeriod: null,
                isOpen: false,
                closedPeriods: [...closedPeriods.map(e => {
                  if (e.id === x.data.id) {
                    return {...x.data};
                  }
                  return e;
                })]
              });
            }
          }
        });
  }

  cancelEdit(){
    this.setState({
      isOpen: false,
    });
  }

  getColumns() {
    return [{
      id: 'dateFrom',
      Header: 'From',
      accessor: x => moment(x.dateFrom).format(dateFormat),
      sortMethod: (a, b) => {
        return moment(a, dateFormat).isAfter(moment(b, dateFormat)) ? 1 : -1;
      },
      maxWidth: 100,
      Filter: ({filter, onChange}) => <span/>,
    }, {
      id: 'dateTo',
      Header: 'To',
      accessor: x => moment(x.dateTo).format(dateFormat),
      sortMethod: (a, b) => {
        return moment(a, dateFormat).isAfter(moment(b, dateFormat)) ? 1 : -1;
      },
      maxWidth: 100,
      Filter: ({filter, onChange}) => <span/>,
    },
      {
        Header: 'Description',
        accessor: 'description',
        filterMethod: (filter, row) => {
          return row[filter.id] !== null ? row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) >= 0 : false;
        },
      },
      {
        Header: 'Is Annual',
        accessor: 'isAnnual',
        Cell: row => <div style={{textAlign: 'center', width: '100%'}}><i
            className={row.value ? 'fa fa-check text-success' : 'fa fa-times text-danger'}/></div>,
        maxWidth: 100,
        Filter: ({filter, onChange}) => <span/>,
      },
      {
        id: 'updatedDate',
        Header: 'Updated',
        accessor: x => moment(x.updatedDate).format(dateFormat),
        sortMethod: (a, b) => {
          return moment(a, dateFormat).isAfter(moment(b, dateFormat)) ? 1 : -1;
        },
        maxWidth: 100,
        Filter: ({filter, onChange}) => <span/>,
      },
      {
        Header: 'Updated By',
        accessor: 'updatedByUserName',
        filterMethod: (filter, row) => {
          return row[filter.id] !== null ? row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) >= 0 : false;
        },
        maxWidth: 100,
      },
      {
        id: 'actions',
        Header: '',
        accessor: c => {
          return (
              <span>
                {!c.isPast &&
                <a href={''}
                   style={{marginRight: '20px'}}
                   onClick={(e) => this.handleSelectEdit(e, c)}
                ><i className="fa fa-edit"/></a>}
                {!c.isPast && !c.isStarted &&
                <a href={''}
                   onClick={(e) => this.handleSelectDelete(e, c)}
                ><i className="fa fa-times"/></a>}
            </span>
          );
        },
        width: 125,
      },
    ];
  }

  async loadData(load = true) {
    let {locationId} = this.props;
    if(load) {
      this.setState({loading: true, closedPeriods: []});
    }
    await apiRequest(`/api/closedPeriods?locationId=${locationId}`)
        .then(x => {
          if (x.error || x.data.Message) {
            toastr.error(`Error while fetching, error: ${x.error ? x.error : x.data.Message}`);
            this.setState({loading: false});
          } else {
            this.setState({closedPeriods: Array.from(x.data), loading: false});
          }
        });
  }

  componentDidMount(){
    this.loadData().then(() => {});
  }

  render() {
    let {closedPeriods, selectedClosedPeriod, isOpen} = this.state;
    let {locationId} = this.props;

    return (<div style={{marginBottom: '15px'}}>

      <ClosedPeriodView isOpen={isOpen} closedPeriod={selectedClosedPeriod} closedPeriods={closedPeriods} onSave={this.saveClosedPeriod} onCancel={this.cancelEdit} />

      <div className="row">
        <div className={'col-12'}>
          <h6>
            Closed Periods
            <Button color="success" onClick={this.handleNew} style={{marginLeft: '10px'}}><i className="fa fa-plus"/>&nbsp;&nbsp;Add</Button>
          </h6>
        </div>
      </div>
      <div className="row">
        <div className={'col-12'}>
          <ReactTable
              sortable={true}
              filterable={false}
              showPagination={true}
              data={closedPeriods}
              columns={this.getColumns()}
              defaultPageSize={5}
              minRows={2}
              defaultSorted={[{id: 'dateFrom', desc: true}]}
          />
        </div>
      </div>
    </div>);
  }
}

ClosedPeriodsView.propTypes = {
  locationId: PropTypes.number.isRequired,
};

export default ClosedPeriodsView;